// export const AMEND_ADDRESS='amend_address'
// export const AMEND_FOODLIST='amend_FoodList'
// export const AMEND_PLACESHOP='amend_PlaceShop'
// export const AMEND_USER='amend_user'
// export const AMEND_TOKEN='amend_token'
// export const RESET_USER='reset_user'
// export const RESET_TOKEN='reset_token'
// //shop
// export const AMEND_ORDER='amend_order'
// export const AMEND_COMMENT='amend_comment'
// export const AMEND_SELLE='amend_selle'
// export const AMEND_CART='amend_cart'
// export const AMEND_SHOP='amend_shop'

export const AMEND_BAR='amend_bar'
export const AMEND_USER='amend_user'
export const AMEND_LOGIN='amend_login'
export const AMEND_OUTLOGIN='amend_outlogin'
export const AMEND_DIALOG = 'amend_dialog'
export const AMEND_ADDPATH = 'amend_addpath'
export const AMEND_CATEGORY = 'amend_category'
export const AMEND_GOODSDATA = 'amend_goodsdata'
export const AMEND_USERTITLE = 'amend_usertitle'
export const AMEND_VISIBLE = 'amend_visible'
export const AMEND_INFORMATION = 'amend_information'


